import React from 'react'
import { usePopperTooltip } from 'react-popper-tooltip'
import './popover.scss'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

const offset = [0, 15] // For the arrow-tip not to be on top of the trigger button

/** basic popover  */
const Popover = ({ container, containerClass, trigger, popoverClass, children, appendToBody, ...rest }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible
  } = usePopperTooltip({ trigger, offset, ...rest })

  const tooltipWrapper = <div
    ref={setTooltipRef} {...getTooltipProps({ className: `Suc-tooltip-container ${popoverClass}` })}>
    {children}
    <div
      {...getArrowProps({
        className: 'Suc-tooltip-arrow'
      })}
    />
  </div>

  return (
    <>
      <span className={`Suc-popover-trigger-container ${containerClass} ${visible ? 'active' : ''}`}
            ref={setTriggerRef}>{container}</span>
      {visible && (appendToBody ? ReactDOM.createPortal(tooltipWrapper, document.body) : tooltipWrapper)}
    </>
  )
}
Popover.propTypes = {
  /** variant of trigger */
  trigger: PropTypes.oneOf(['click', 'hover']),
  /** custom classname for the trigger element */
  containerClass: PropTypes.string,
  /** custom classname for the tooltip element */
  popoverClass: PropTypes.string,
  /** append tooltip to body */
  appendToBody: PropTypes.bool,
  /** placement direction of the element */
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /** Tooltip element */
  children: PropTypes.node
}

Popover.defaultProps = {
  trigger: 'click',
  containerClass: '',
  popoverClass: '',
  placement: 'bottom',
  appendToBody: false
}

export default Popover
